import React from 'react';
import { Spin } from 'antd';
import styles from './empty-loading-state.module.sass';

const EmptyLoadingState = () => {
  return (
    <div className={styles.empty_loading_state}>
      <Spin size="large" />
    </div>
  );
};

export default EmptyLoadingState;
